export default __webpack_public_path__ + "static/r600-bg-image-8b400731482d9ce50bde66f55ffb4b0e.png";